module.exports = __webpack_public_path__ + "static/media/Accounts_menu.4e797d3d.svg";